import React from 'react';
import PropTypes from 'prop-types';

import styles from './QuestionDisplay.scss';
import QuestionRubricBlock from './QuestionRubricBlock';
import questionRubricBlockWithTitleSelector from '../../selectors/question/QuestionRubricBlockWithTitleSelector';

const QuestionRubricBlockWithTitleContent = (props) => {
    const {
        isSectionLevel,
        question,
        scorableItemId,
        showRubric,
        showTitle,
        useDynamicRubric,
        questionRubricTitle,
    } = props;

    const classList = ['question-rubric', styles.questionRubricBlock];

    if (useDynamicRubric) {
        classList.push(styles.dynamicRubric);
    }

    if (isSectionLevel) {
        classList.push(styles.sectionLevelDynamicRubric);
    }

    if (!showTitle && !showRubric) {
        return null;
    }

    return (<div className={classList.join(' ')}>
        { showTitle &&
            <h3 className="scorableItemHeadline" id={scorableItemId}>
                {questionRubricTitle}
            </h3>
        }

        { showRubric && <QuestionRubricBlock question={question} /> }
    </div>);
};

QuestionRubricBlockWithTitleContent.propTypes = {
    isSectionLevel: PropTypes.bool,
    question: PropTypes.object.isRequired,
    scorableItemId: PropTypes.string.isRequired,
    showRubric: PropTypes.bool.isRequired,
    showTitle: PropTypes.bool.isRequired,
    useDynamicRubric: PropTypes.bool.isRequired,
    questionRubricTitle: PropTypes.string.isRequired,
};

const QuestionRubricBlockWithTitle = props => (
    <QuestionRubricBlockWithTitleContent {...props} {...questionRubricBlockWithTitleSelector.selectProps(props)} />
);

export default QuestionRubricBlockWithTitle;
